import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Header.css';
import logo from '../assets/icons/logo.svg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0 });
    // 关闭移动端菜单
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const handleLogin = () => {
    window.location.href = 'https://core.xingsnb.cn';
  }

  return (
    <motion.header
      className="header"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="container">
        <motion.div
          className="logo"
          transition={{ type: "spring", stiffness: 400, damping: 10 }}
        >
          <Link to="/" onClick={() => handleNavigation('/')}>
            <motion.img
              src={logo}
              alt="星晟Logo"
              className="logo-image"
              transition={{ type: "spring", stiffness: 300 }}
            />
            <motion.span
              style={{ marginLeft: 16, fontSize: 20 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              星晟工程数智
            </motion.span>
          </Link>
        </motion.div>

        {/* 移动端菜单按钮 */}
        <button
          className={`mobile-menu-btn ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
          <ul>
            <motion.li whileHover={{ y: -5 }} className={location.pathname === '/' ? 'active' : ''}>
              <Link to="/" onClick={() => handleNavigation('/')}>首页</Link>
            </motion.li>
            <motion.li whileHover={{ y: -5 }} className={location.pathname.startsWith('/product') ? 'active' : ''}>
              <Link to="/product" onClick={() => handleNavigation('/product')}>产品服务</Link>
            </motion.li>
            <motion.li whileHover={{ y: -5 }} className={location.pathname.startsWith('/case-studies') ? 'active' : ''}>
              <Link to="/case-studies" onClick={() => handleNavigation('/case-studies')}>成功案例</Link>
            </motion.li>
            <motion.li whileHover={{ y: -5 }} className={location.pathname === '/calculation-library' ? 'active' : ''}>
              <Link to="/calculation-library" onClick={() => handleNavigation('/calculation-library')}>计算库</Link>
            </motion.li>
            <motion.li whileHover={{ y: -5 }} className={location.pathname === '/ai-qa' ? 'active' : ''}>
              <Link to="/ai-qa" onClick={() => handleNavigation('/ai-qa')}>AI 问答</Link>
            </motion.li>
            <motion.li whileHover={{ y: -5 }} className={location.pathname === '/about' ? 'active' : ''}>
              <Link to="/about" onClick={() => handleNavigation('/about')}>关于我们</Link>
            </motion.li>
            <li className="auth-buttons" onClick={() => handleLogin()}>
              <button className="login-btn">登录</button>
              <button className="register-btn">注册</button>
            </li>
          </ul>
        </nav>
      </div>
    </motion.header>
  );
};

export default Header;